module.exports = __webpack_public_path__ + "static/media/prometheus.ec55c408.png";